/**
 * Section-form Verkaufen/Tauschen switch; its searchbar autocomplete lives elsewhere.
 * @see ./search-autocomplete.js
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    const switchBtn = e.target.closest('.js_section_form_switch');
    if (!switchBtn) {
      return;
    }

    const section = switchBtn.closest('.js_section_form');
    if (!section) {
      return;
    }

    const targetView = switchBtn.dataset.view;

    section.querySelectorAll('.js_section_form_switch').forEach(function (btn) {
      const isActive = btn === switchBtn;
      btn.classList.toggle('category_switch__item--active', isActive);
      btn.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    section.querySelectorAll('.js_section_form_view').forEach(function (view) {
      view.hidden = view.dataset.view !== targetView;
    });
  });
})();
